module.exports = __webpack_public_path__ + "img/header.eea5d02e.svg";